<h4 class="modal-title">
    <ng-container *ngIf="selectedCustomerForNewTerm">
        <ng-container i18n="@@app.main.popup.calendar.header.title.patient">Izberi termin za stranko:</ng-container>
        <strong>
            {{ selectedCustomerForNewTerm?.name }}
            {{ selectedCustomerForNewTerm?.surname }}
        </strong>
    </ng-container>
</h4>
